<template>
    <div v-cloak>
        <div class="row">
            <div class="col-md-12">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link :to="{name:'home'}">{{$t("inicio")}}</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">{{$t('camaras')}}</li>
                    </ol>
                </nav>
            </div>

            <!--<div class="col-md-12">
                <div class="card">
                    <div class="row">
                        <div class="col-md-3" v-for="(cam,index) in cams">
                            <div class="row">
                                <div class="col-md-12" style="cursor: pointer">
                                    <span @click="openModal(index)" v-html="cam.html" style='width:100%;'
                                          class="imgCam"></span>
                                </div>

                                <div class="col-md-12" style="margin-top: 10px;">
                                    <h5>{{cam.name}}
                                        <a :href="cam.camPage" target="_blank">
                                            <i class="fa fa-cog " style="float: right"></i>
                                        </a>
                                    </h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <modal name="modal-cam" :adaptive=true :scrollable=true height="auto" :clickToClose=true>
                <div>
                    <div class="modal-body">
                        <span v-html="cams[indexCamara].htmlVideo" v-if="cams.length>0"></span>
                    </div>
                    <div class="modal-footer">
                        <div align="right" class="col-12">
                            <button class="btn" @click="closeModal()"><i class="fa fa-window-close"></i>
                                {{$t("cerrar")}}
                            </button>
                        </div>
                    </div>
                </div>
            </modal>-->
        </div>
    </div>
</template>

<script>
    import {DatePicker, Select, Option, Dropdown, DropdownItem, DropdownMenu, Button} from 'element-ui'
    import {Loading} from 'element-ui';
    import swal from 'sweetalert2'

    export default {
        name: "Camaras",

        data() {
            return {

                indexCamara: 0,
                cams: [],
            }
        },
        created() {

            //this.getCamaras();

        },
        methods: {

            openModal(index) {
                this.indexCamara = index;
                this.$modal.show("modal-cam");
            },

            closeModal() {
                this.$modal.hide("modal-cam");
            },

            getCamaras() {
                var config = {
                    params: {
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.axios.get(this.$store.getters.apiUrl + "online/getCamaras", config)
                    .then(function (response) {

                        if (response.data.response) {

                            vm.cams = response.data.result;

                        } else {

                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.message,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                        }
                    })
                    .catch(function (error) {
                        vm.$router.push("serverdown");
                        vm.loading.close();
                    });
            }
        }
    }
</script>

<style scoped>

    [v-cloak] {
        display: none;
    }

    tbody tr:hover {
        background-color: rgba(0, 153, 130, 0.2);
    }

    tbody td {
        padding: 0 !important;
    }

    td div {
        padding: 12px 8px;
        color: #333;
    }

    .buttonsSearch:hover {
        cursor: pointer;
        background-color: rgba(0, 153, 130, 0.1);
    }

    .card {
        padding: 20px;
    }

    .input-group button {
        height: 40px;
    }

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/Camaras/Camaras.vue